// extracted by mini-css-extract-plugin
module.exports = {"page":"LoadingPage-page-32PQ7 Page-page-jTeFt"};